import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=064818ba&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"
import style0 from "./Logout.vue?vue&type=style&index=0&id=064818ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064818ba",
  null
  
)

/* custom blocks */
import block0 from "./Logout.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports